import { Component, Type } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { PoprPriority } from '../../../shared/components/popr/popr-priority.enum';
import { PoprService } from '../../../shared/components/popr/popr.service';

import { ContactComponent } from '../../contact/contact.component';
import { PoprToastLaboratoryComponent } from '../toast/popr-toast-laboratory.component';
import { SampleComponent } from './sample.component';

@Component({
  selector: 'wpro-popr-modal-laboratory',
  templateUrl: './popr-modal-laboratory.component.html',
  standalone: false
})

export class PoprModalLaboratoryComponent {
  readonly priorities = Object.values(PoprPriority).filter(value => typeof value === 'string');
  readonly components: Type<any>[] = [SampleComponent, PoprToastLaboratoryComponent, ContactComponent];

  readonly modalComponentControl = new UntypedFormControl(this.components[0]);
  readonly modalTitleComponent = new UntypedFormControl();
  readonly modalFormGroup = new UntypedFormGroup({
    component: this.modalComponentControl,
    title: this.modalTitleComponent
  });

  constructor(
    private poprService: PoprService
  ) {
  }

  buildModal(): void {
    const modal = this.poprService.createModal(
      this.modalComponentControl.value,
      this.modalTitleComponent.value
    );

    if (this.modalComponentControl.value === SampleComponent) {
      modal.component$().pipe(
        switchMap((comp: SampleComponent) => comp.color)
      ).subscribe((color: string) => {
        modal.close();
        this.poprService.createToast(PoprPriority.SUCCESS, color);
      });
    } else if (this.modalComponentControl.value === PoprToastLaboratoryComponent) {
      modal.component$().pipe(
        switchMap((comp: PoprToastLaboratoryComponent) => comp.toastEvent)
      ).subscribe(() => modal.close());
    }
  }

  cancelAllPoprs(): void {
    this.poprService.clear();
  }
}
